<template>
  <div class="notify" :class="theme" v-bind="$attrs">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['theme']
}
</script>

<style scoped lang="scss">
  .notify {
    border: 1px solid rgba(27, 217, 210, 0.3);
    background-color: rgba(27, 217, 210, 0.1);
    border-radius: var(--attendee-card-border-radius);
    font-size: 14px;
    line-height: 20px;
    padding: var(--attendee-gap-md);
    display: block;
    color: var(--attendee-text-primary-color);

    &.danger {
      border: 1px solid rgba(185, 74, 72, 0.3);
      background-color: #f2dede;
      color: rgba(185, 74, 72, 1);
    }

    &.warning {
      border: 1px solid rgba(255, 193, 7, 0.3);
      background-color: #fcf8e3;
      color: var(--attendee-text-primary-color);
    }

    &.primary {
      border: 1px solid rgba(27, 217, 210, 0.3);
      background-color: rgba(27, 217, 210, 0.1);
      color: var(--attendee-text-primary-color);
    }

    &.success {
      border: 1px solid rgba(18, 194, 41, 0.3);
      background-color: rgba(27, 217, 94, 0.1);
      color: var(--attendee-text-primary-color);
    }
  }
</style>
